/**
 * Maneja el estado de las recompensas y sus cálculos
 */
class RewardsDataHandler {
  constructor() {
    this.lastStep = 0;
    this.pointsMultiplier = window.NATULIM.REWARDS.SETTINGS.pointsMultiplier;
    this.pointsMultiplierForSub = window.NATULIM.REWARDS.SETTINGS.pointsMultiplierForSub;
    this.stepsToPoints = window.NATULIM.REWARDS.STEPS;
    this.cartData = null;
    this.updateInProgress = false;
  }

  async update(cartData) {
    if (this.updateInProgress) return;
    
    try {
      this.updateInProgress = true;
      this.cartData = cartData;

      console.log("======== Detección de cambio en carrito o primera vez que se abre la ventana. Se actualizarán los datos de puntos en RewardsDataHandler y se emitirá un evento: =========", this.cartData)
      
      // Calcular valores básicos
      this.totalPrice = (cartData.total_price / 100).toFixed(2);
      this.earnedPoints = this.getTotalEarnedPoints();
      
      // Actualizar pasos
      if (typeof this.currentStep !== 'undefined') {
        this.lastStep = this.currentStep;
      }
      this.currentStep = this.getStepFor(this.earnedPoints);
      
      // Calcular métricas adicionales
      this.donatedUnits = (this.earnedPoints / 20).toFixed(0);
      this.totalDiscount = (cartData.total_discount / 100).toFixed(2);
      const discount = NATULIM.REWARDS.SETTINGS.discountPct / 100;
      this.totalSavings = this.getTotalSavedMoney().toFixed(2)

      // Emitir evento de actualización
      this.emitUpdateEvent();
       } catch (error) {
        console.error('Error al actualizar el carrito:', error);
    } finally {
      this.updateInProgress = false;
    }
  }
  
  getTotalSavedMoney() {
    function extractCartItemsData() {
      const cartItems = document.querySelectorAll('#CartDrawer .cart-item');
        
      return Array.from(cartItems).map(item => ({
          price: parseFloat(item.dataset?.price || 0 ),
          comparePrice: parseFloat(item.dataset?.comparePrice || 0),
          variant: item.dataset?.variant || 0
      }));
    }
    
    const cartItemsData = extractCartItemsData()
      

    let savedMoneyInCents = 0;
    this.cartData.items.forEach(item => {
    const quantity = item.quantity 
    let comparePrice
    let price

    const cartItem = cartItemsData.find(cartItem => cartItem.variant.toString() === item.variant_id.toString());
    if (cartItem) {
      comparePrice = cartItem.comparePrice
      if (item.selling_plan_allocation)  {
         price = item.selling_plan_allocation.per_delivery_price
      } else {
         price = cartItem.price; 
      }
    } else {
        console.warn(`El producto con variant_id ${item.variant_id} no tiene datos en el cart-drawer. ¿Es un producto de ONG?`)
        comparePrice = 0
        price = 0;
    }
        
      const isRewardProduct = window.NATULIM.REWARDS.manager.isRewardProduct(item.variant_id);
      if (comparePrice > price && !isRewardProduct) {
        savedMoneyInCents += (comparePrice - price) * quantity;
      }                         
    });

    return savedMoneyInCents / 100;
    
  }
  
  getTotalEarnedPoints() {
    let subEarnedPoints = 0;
    let normalEarnedPoints = 0;
    this.cartData.items.forEach(item => {
      if (item.selling_plan_allocation)  {
        subEarnedPoints += item.final_line_price;
      } else {
        normalEarnedPoints += item.final_line_price;
      }
    });
    console.log("sub --->"+subEarnedPoints)
    console.log("normal --->"+normalEarnedPoints)
    console.log(Math.round((subEarnedPoints * this.pointsMultiplierForSub + normalEarnedPoints * this.pointsMultiplier) / 100))
    return Math.round((subEarnedPoints * this.pointsMultiplierForSub + normalEarnedPoints * this.pointsMultiplier) / 100)
  }

  
  getStepFor(points) {
    let step = 0;
    for (const stepData of this.stepsToPoints) {
      if (points >= stepData.stepValue) {
        step = stepData.stepNumber;
      } else {
        break;
      }
    }
    return step;
  }

  emitUpdateEvent() {
    const event = new CustomEvent('rewardsDataUpdated', {
      detail: {
        currentStep: this.currentStep,
        lastStep: this.lastStep,
        earnedPoints: this.earnedPoints,
        totalPrice: this.totalPrice
      }
    });
    document.dispatchEvent(event);
  }
}

/**
 * Gestiona la adición y eliminación de recompensas en el carrito
 */
class RewardsManager {
  constructor(rewardsData) {
    this.rewardsData = rewardsData;
    this.nspbSteps = window.NATULIM.REWARDS.STEPS;
    this.cart = document.querySelector('cart-drawer');
    this.fixedCart = document.querySelector('fixed-cart');
    this.updateQueue = [];
    this.isProcessing = false;
    this.processDelay = 500;
    this.donationVariants = [49760262357331, 49760262291795, 49760262259027, 49760262324563];

    // Escuchar actualizaciones de rewardsData
    document.addEventListener('rewardsDataUpdated', (event) => {
      this.handleRewardsUpdate(event.detail);
    });
  }

  async handleRewardsUpdate({ currentStep, lastStep }) {
    const outOfSync = this.isCartOutOfSync(this.rewardsData.cartData);
    console.log("===== handleRewardsUpdate consultó si el carrito está desincronizado: ", outOfSync)
    if ((currentStep !== lastStep) || outOfSync) {
      console.log("===== handleRewardsUpdate detectó que el cliente está en otro umbral de precio y se deben actualizar sus regalos =========")
      await this.addOrDeleteRewards();
    } else {
      console.log("===== handleRewardsUpdate detectó que no es necesario añadir o eliminar regalos =========")
    }
  }

  async addOrDeleteRewards() {
    if (this.isProcessing) {
      return new Promise((resolve) => {
        this.updateQueue.push(() => this.addOrDeleteRewards().then(resolve));
      });
    }

    this.isProcessing = true;

    try {
      const cartData = this.rewardsData.cartData;
      const { needsUpdate, updatedCartItems } = this.calculateCartUpdates(cartData);

      if (needsUpdate) {
        await this.updateCart(updatedCartItems);
      }
    } catch (error) {
      console.error('Error en addOrDeleteRewards:', error);
    } finally {
      this.isProcessing = false;

      setTimeout(() => {
        const nextUpdate = this.updateQueue.shift();
        if (nextUpdate) {
          nextUpdate();
        }
      }, this.processDelay);
    }
  }

  calculateCartUpdates(cartData) {
    const updatedCartItems = {};
    let needsUpdate = false;

    // Mantener productos normales
    cartData.items.forEach(item => {
      if (!this.isRewardProduct(item.variant_id) && !this.donationVariants.includes(item.variant_id)) {
        updatedCartItems[item.key] = item.quantity;
      }
    });

    // Obtener las recompensas que están en el carrito
    const rewardsInCart = new Map();
    cartData.items.forEach(item => {
      if (this.isRewardProduct(item.variant_id)) {
        rewardsInCart.set(item.variant_id, item.quantity);
      }
    });

    // Procesar cada paso y revisar que el número de recompensas sea correcto
    this.nspbSteps.forEach(rewardStep => {
      const shouldHaveReward = rewardStep.stepNumber <= this.rewardsData.currentStep;

      if (rewardStep.variantId) {
        const rewardQuantityInCart = rewardsInCart.get(rewardStep.variantId) || 0;

        if (shouldHaveReward && rewardQuantityInCart !== 1) {
          needsUpdate = true;
          updatedCartItems[rewardStep.variantId] = 1;
        } else if (!shouldHaveReward && rewardQuantityInCart > 0) {
          needsUpdate = true;
          updatedCartItems[rewardStep.variantId] = 0;
        }
      }
    });

    
    /* Verificar donaciones
    if (this.shouldAddDonation(cartData) || this.shouldChangeDonationQuantity(cartData)) {
      const donatedUnits =  Number(this.rewardsData.donatedUnits);
      
      if (this.shouldAddDonation(cartData)) {
        updatedCartItems[this.donationVariants[0]] = donatedUnits;
      } else {
        const donationVariantInCart = cartData.items.find(item => this.donationVariants.includes(item.variant_id)); 
        if (donationVariantInCart) {
          updatedCartItems[donationVariantInCart.variant_id] = donatedUnits;
        }
      }
      needsUpdate = true;
    } else if (this.shouldDeleteDonation(cartData)) {
      const variantToDelete = cartData.items.find(item => this.donationVariants.includes(item.variant_id));
      
      if (variantToDelete) {
        updatedCartItems[variantToDelete.variant_id] = 0;
        needsUpdate = true;        
      }
    }*/

    return { needsUpdate, updatedCartItems };
  }

  async updateCart(updatedItems) {
    try {   
      const cartSections = this.cart.getSectionsToRender().map((section) => section.id) || [];
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: updatedItems,
          sections: cartSections,
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        throw new Error(`Error en updateCart: ${response.status}`);
      }

      const data = await response.json();


      if (this.cart) {
        setTimeout(() => {
          this.cart.renderContentsNoOpen(data);
          this.fixedCart?.renderContents(data);
        });
      }

      // Emitir evento de actualización completada
      document.dispatchEvent(new CustomEvent('cartUpdateComplete', { detail: data }));

    } catch (error) {
      console.error('Error al actualizar el carrito:', error);
      throw error;
    }
  }

  async showCart() {
    console.log("Se llamó a showCart");
    let response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error(`Error al obtener el carrito en showCart: ${response.status}`);
    }
    const cartData = await response.json();
    console.log("CartData:", cartData);
    
    const updatedCartItems = {};

    // Mantener los productos
    cartData.items.forEach(item => {
        updatedCartItems[item.key] = item.quantity;
    });

    console.log("-------- updatedCartItems es ", updatedCartItems)
                           

    
    const cartItems = document.querySelector('cart-drawer-items');
    window.miCartItems = cartItems;
    console.log("Se llamó a showCart. cartItems es:", cartItems)

      const cartSections = this.cart.getSectionsToRender().map((section) => section.id) || [];
      response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: updatedCartItems,
          sections: cartSections,
          sections_url: window.location.pathname
        })
      });

      if (!response.ok) {
        throw new Error(`Error en showCart: ${response.status}`);
      }

      const data = await response.json();

      if (this.cart) {
        setTimeout(() => {
          this.cart.renderContentsNoOpen(data);
         
        },100);
      }
    
  }
 

  getSectionsToRender() {
    return [
       {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset?.id,
        selector: '.js-contents',
      },
    ];
  }

  
  isRewardProduct(variantId) {
    return this.nspbSteps.some(step => step.variantId === variantId);
  }

  
  shouldAddDonation(cartData) {
    let shouldAdd = false;
    const hasDonation = cartData.items.some((item) => 
      this.donationVariants.includes(item.variant_id) 
    );
     if (!hasDonation && this.rewardsData.earnedPoints >= 20) {
       shouldAdd = true;
     }  
    return shouldAdd;
  }

  
  shouldDeleteDonation(cartData) {
    let shouldDelete = false;
     const hasDonation = cartData.items.some((item) => 
      this.donationVariants.includes(item.variant_id) 
    );
    if (hasDonation && this.rewardsData.earnedPoints < 20) {
        shouldDelete = true;
    }
    return shouldDelete;
  }

  shouldChangeDonationQuantity(cartData) {
    const donationVariant = cartData.items.find(item => this.donationVariants.includes(item.variant_id));
    if (donationVariant) {
      if (Number(donationVariant.quantity) !== Number(this.rewardsData.donatedUnits)) {
          return true;
      }
    }
    return false;
  }
  
  shouldAddOrDeleteDonation(cartData) {    
    if (this.shouldAddDonation(cartData)) {
        return true;
    }
     if (this.shouldDeleteDonation(cartData)) {
       return true;
     }  
    return false;  
  }

  shouldChangeDonation(cartData) {
    return this.shouldAddOrDeleteDonation(cartData) || this.shouldChangeDonationQuantity(cartData)
  }
  
   isCartOutOfSync(cartData) {
    const currentPoints = this.rewardsData.earnedPoints;
    let hasDesyncs = false;

    cartData.items.forEach(item => {
      if (this.isRewardProduct(item.variant_id)) {
        const step = this.nspbSteps.find(s => s.variantId === item.variant_id);
        if (step && currentPoints < step.stepValue) {
          hasDesyncs = true;
        }
      }
    });

     /*if (this.shouldChangeDonation(cartData)) {
        hasDesyncs = true;
    }*/
    return hasDesyncs;
  }
}

/**
 * Maneja las actualizaciones de la UI de la barra de progreso
 */
class NatulimStepProgressBarManager {
  constructor(config = {}) {
    this.circles = document.querySelectorAll(".nspb-circle");
    this.progressBar = document.querySelector(".nspb-indicator");
    this.startProgressBar = document.querySelector(".nspb-indicator-start");
    this.stepsToPoints = window.NATULIM.REWARDS.STEPS;
    
    this.config = {
      activeColor: '#A4DCCF',
      inactiveGradient: 'linear-gradient(to right, #A4DCCF 40%, #39B397 6.25%)',
      ...config
    };

    // Escuchar actualizaciones de rewardsData
    document.addEventListener('rewardsDataUpdated', (event) => {
      this.updateProgress(event.detail);
    });
  }

  updateProgress({ currentStep, earnedPoints }) {
    const progressPercentage = this.calculateProgressPercentage(currentStep, earnedPoints);
    this.updateVisuals(currentStep, progressPercentage);
  }

  calculateProgressPercentage(currentStep, earnedPoints) {
    const firstContainer = document.querySelector('.nspb-steps');
    const circleCount = firstContainer ? firstContainer.querySelectorAll('.nspb-circle').length : 0;
    let stepFraction
    if (circleCount === 1) {
      stepFraction = 0;
    } else {
      stepFraction = 1 / (circleCount - 1);
    }
    
    const currentStepValue = this.stepsToPoints[currentStep]?.stepValue || 0;
    const isMidStepProgress = earnedPoints > this.stepsToPoints[currentStep].stepValue;
    const midStepProgressPct = isMidStepProgress ? (stepFraction / 2) * 100 : 0;
    
    let stepProgressPct;
    if (currentStep >= 1) {
      if (circleCount === 1) {
        stepProgressPct = 50
      } else {
        stepProgressPct = ((currentStep - 1) / (circleCount - 1)) * 100;
      }
    }  else {
      stepProgressPct = 0;
    }

   
    return {
      total: stepProgressPct + (currentStep >= 1 ? midStepProgressPct : 0),
      isFirstStep: currentStep >= 1
    };
  }

  calculateProgressPercentage2(currentStep, earnedPoints) {
    const firstContainer = document.querySelector('.nspb-steps');
    const circleCount = firstContainer ? firstContainer.querySelectorAll('.nspb-circle').length : 0;
    const stepFraction = 1 / (circleCount - 1);
    
    const currentStepValue = this.stepsToPoints[currentStep]?.stepValue || 0;
    const isMidStepProgress = earnedPoints > this.stepsToPoints[currentStep].stepValue;
    const midStepProgressPct = isMidStepProgress ? (stepFraction / 2) * 100 : 0;
    
    let stepProgressPct;
    if (currentStep >= 1) {
      stepProgressPct = ((currentStep - 1) / (circleCount - 1)) * 100;
    } else {
      stepProgressPct = 0;
    }

   
    return {
      total: stepProgressPct + (currentStep >= 1 ? midStepProgressPct : 0),
      isFirstStep: currentStep >= 1
    };
  }

  updateVisuals(currentStep, progressPercentage) {
    console.log("+++++++++ >"+currentStep)
    console.log("+++++++++ >"+JSON.stringify(progressPercentage))
    // Actualizar círculos
    const stepsContainers = document.querySelectorAll('.nspb-steps');
    stepsContainers.forEach(container => {
        const circles = container.querySelectorAll('.nspb-circle');
        circles.forEach((circle, index) => {
            circle.classList.toggle("active", index < currentStep);
        });
    });

    // Actualizar barra de progreso
    const progressBars = document.querySelectorAll('.nspb-indicator');
    console.log(progressBars[0])
    progressBars.forEach(bar => {
      
        bar.setAttribute("style", `width: ${progressPercentage.total}% !important;`);
        //bar.style.width =  `${progressPercentage.total}% !important;`;
    });
    
    
    // Actualizar color de la barra inicial
    document.documentElement.style.setProperty(
      '--nspb-zero-step-progress',
      progressPercentage.isFirstStep ? this.config.activeColor : this.config.inactiveGradient
    );
  }
}

/**
 * Coordina las actualizaciones del carrito y mantiene la sincronización
 */
class CartManager {
  constructor(rewardsData) {
    this.rewardsData = rewardsData;
    this.setupCartListeners();
  }

  setupCartListeners() {
    const originalFetch = window.fetch;
    
    window.fetch = async (...args) => {
      const response = await originalFetch.apply(window, args);
      
      if (this.isCartUpdateRequest(args[0])) {
        await this.handleCartUpdate();
      }
      
      return response;
    };

    // Escuchar actualizaciones completas del carrito
    document.addEventListener('cartUpdateComplete', async () => {
      await this.handleCartUpdate();
    });
  }

  isCartUpdateRequest(url) {
    if (!url) return false;
    const cartEndpoints = ['/cart/add', '/cart/update', '/cart/change', '/cart/clear'];
    return cartEndpoints.some(endpoint => 
      url.toString().toLowerCase().includes(endpoint)
    );
  }

  async handleCartUpdate() {
    try {
      const cartData = await this.getCartData();
      await this.rewardsData.update(cartData);
      this.updateInfoBar();
    } catch (error) {
      console.error('Error en handleCartUpdate:', error);
    }
  }

  async getCartData() {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error(`Error al obtener el carrito: ${response.status}`);
    }
    return response.json();
  }

  updateInfoBar() {
    const updateElement = (selector, value) => {
      document.querySelectorAll(selector).forEach(el => {
          el.textContent = value;
        });
      };
  
  updateElement('.nspb-data-total-saved', `${this.rewardsData.totalSavings}€`);
  updateElement('.nspb-data-current-step', this.rewardsData.currentStep);
  updateElement('.nspb-data-donated-units', this.rewardsData.donatedUnits);
  }
}



window.NATULIM = window.NATULIM || {};
window.NATULIM.REWARDS = window.NATULIM.REWARDS || {};

function initializePointsAndRewards() {
  if (window.NATULIM?.REWARDS?.isInitialized) {
    return;
  }
  console.log('Initializing Points And Rewards System...');
  window.NATULIM.REWARDS.rewardsData = new RewardsDataHandler();
  window.NATULIM.REWARDS.manager = new RewardsManager(window.NATULIM.REWARDS.rewardsData);
  window.NATULIM.REWARDS.progressBar = new NatulimStepProgressBarManager();
  window.NATULIM.REWARDS.cart = new CartManager(window.NATULIM.REWARDS.rewardsData);

  window.NATULIM.REWARDS.cart.handleCartUpdate().catch(error => {
    console.error('Error during initialization or the Points and Rewards System:', error);
  });

  // Marcar como inicializado
  window.NATULIM.REWARDS.isInitialized = true;

}

// Inicialización del sistema 
window.addEventListener('DOMContentLoaded', function() {
  if (window.NATULIM?.REWARDS?.SETTINGS?.isActive && window.NATULIM?.REWARDS?.STEPS) {
      initializePointsAndRewards();
  } 
});
